import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Trophy, Handshake } from 'lucide-react';

function ComparisonSummary({ comparison }) {

  return (
    <Card className="shadow-lg">
      <CardHeader>
        <CardTitle className="text-2xl">AI Analysis Summary</CardTitle>
        <CardDescription>
          Comprehensive comparison analysis powered by AI
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <p className="text-base leading-relaxed">{comparison.summary}</p>
        </div>
        
        {comparison.differences && Object.keys(comparison.differences).length > 0 && (
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Key Differences</h4>
            <div className="grid gap-4 md:grid-cols-2">
              {Object.entries(comparison.differences).map(([category, description]) => (
                <div key={category} className="p-4 rounded-lg border bg-card">
                  <span className="text-sm font-semibold text-primary capitalize block mb-2">
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                  </span>
                  <p className="text-sm text-muted-foreground">{description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {comparison.winner && comparison.winner !== 'tie' && (
          <div className="flex items-center gap-3 p-4 rounded-lg bg-primary/10 border border-primary/20">
            {comparison.winner === 'tie' ? (
              <Handshake className="h-5 w-5 text-primary" />
            ) : (
              <Trophy className="h-5 w-5 text-primary" />
            )}
            <div>
              <span className="font-semibold">Winner: </span>
              <span className="font-bold text-primary">
                {comparison.winner === 'player1' ? 'Player 1' : 'Player 2'}
              </span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default ComparisonSummary;
